import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonImg,
  IonItem,
  IonLabel,
  IonModal,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonRow,
  useIonViewDidEnter,
  useIonViewDidLeave,
  useIonViewWillLeave,
} from "@ionic/react";
import { Link, useHistory, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import TopLeftUserName from "../components/TopLeftUserName";

import AssessmentDescription from "../components/modals/assessment-description";
import { useRecoilState, useResetRecoilState } from "recoil";
import {
  assessmentControlState,
  audioInstructionsEnabledState,
  currentAssessmentState,
  networkConnectionStatus,
  selectedAssessmentState,
} from "../data/atoms";
import {
  getAssessmentControl,
  setAssessmentControl,
} from "../utils/assessment-control";
import {
  GetGeneralLookupData,
  GetPatientAssessmentAndLookups,
} from "../services/AuthServices";
import { Option } from "../models/Option";
import { CurrDatetimeInNewFormat } from "../utils/sharedFunction";

const SelectAssessmentType: React.FC = () => {
  let history = useHistory();
  const [isAssessmentSelected, setIsAssessmentSelected] = useState(false);
  const [assessmentDescModal, setShowModal1] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isTouched, setIsTouched] = useState(false);
  const [AssessmentType, setAssessmentType] = useState<Option[]>([]);

  const [selectedAssessmentType, setSelectedAssessmentType] = useRecoilState(
    selectedAssessmentState
  );
  const [audioInstructionsEnabled, setAudioInstructionsEnabled] =
    useRecoilState(audioInstructionsEnabledState);
  const [assessmentControl, setAssessmentControlSelection] = useRecoilState(
    assessmentControlState
  );
  const [selectedId, setSelectedId] = useState(Number);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  // let isTouched = false;
  const resetVariables = () => {
    if (isTouched) {
      setIsTouched(false);
    }
    setIsDisabled(
      selectedAssessmentType && selectedAssessmentType?.id !== 0 ? false : true
    );
    setIsAssessmentSelected(false);
    // setSelectedId(0);
  };

  useEffect(() => {
    if (selectedId !== 0) {
      setTimeout(() => {
        setIsDisabled(false);
      }, 200);
    }
  }, [selectedId]);

  // Audio Instructions as last saved on Angle Calibration; defaults to On the first time
  const savedAudioInstructionsEnabled = (): boolean => {
    try {
      const saved = JSON.parse(localStorage.getItem("audioInstructionsEnabled") ?? "null");
      return typeof saved === "boolean" ? saved : true;
    } catch {
      return true;
    }
  };

  useIonViewDidEnter(() => {
    console.log("useIonViewWillEnter");
    resetVariables();
    // Preselect the last choices; Audio defaults to On and Control to Remote the first time
    setAudioInstructionsEnabled(savedAudioInstructionsEnabled());
    setAssessmentControlSelection(getAssessmentControl());
    GetAssessmentTypeLookup();
  });

  useIonViewDidLeave(() => {
    resetVariables();
    setSelectedId(0);
  });

  const assessmentTypeSelected = (id: number) => {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }

    if (!isTouched) {
      setIsTouched(true);
    }
    //setIsDisabled(false);
    setIsAssessmentSelected(true);
    setSelectedId(id);
    setSelectedAssessmentType((prevState: any) => ({
      ...prevState,
      id: id,
    }));
  };

  const redirectToPatientPage = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setSelectedAssessmentType((prevState: any) => ({
      ...prevState,
      id: 0,
    }));
    setIsAssessmentSelected(false);
    setSelectedId(0);
    history.push("/patient-page");
  };

  const redirectToAssessmentInfoPage = () => {
    //set recoil value

    console.log("saving assessment type: ", selectedId);
    debugger;
    localStorage.setItem("selectedAType", JSON.stringify(selectedId));
    localStorage.setItem("audioInstructionsEnabled", JSON.stringify(audioInstructionsEnabled));
    setAssessmentControl(assessmentControl);
    setSelectedAssessmentType((prevState: any) => ({
      ...prevState,
      id: selectedId,
    }));

    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    history.push("/angle-adjustment");
  };

  async function GetAssessmentTypeLookup() {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    await GetPatientAssessmentAndLookups({
      serverId: Number(localStorage.getItem("patientServerID")!),
      localDateTime: CurrDatetimeInNewFormat(new Date()),
    })
      .then(async function (response) {
        debugger;
        if (response!.data.responseCode === 1 && !isTouched) {
          setAssessmentType(response!.data.assessmentType!);
          // Screening is always preselected, ahead of the patient's last assessment type
          const screeningType = response!.data.assessmentType?.find(
            (type: Option) => type.name?.toLowerCase().includes("screening")
          );
          if (screeningType) {
            if (isDisabled) {
              setIsDisabled(false);
            }
            setIsAssessmentSelected(true);
            setSelectedId(screeningType.id);
            setSelectedAssessmentType((prevState: any) => ({
              ...prevState,
              id: screeningType.id,
            }));
            localStorage.setItem("selectedAType", JSON.stringify(screeningType.id));
          } else if (
            response!.data.selectedPatientAssesmentType !== null &&
            response!.data.selectedPatientAssesmentType.length > 0
          ) {
            if (
              response?.data?.selectedPatientAssesmentType &&
              response?.data?.selectedPatientAssesmentType.length > 0 &&
              response?.data?.selectedPatientAssesmentType[0]?.id &&
              response?.data?.selectedPatientAssesmentType[0]?.id !== 0
            ) {
              if (isDisabled) {
                setIsDisabled(false);
              }
              setIsAssessmentSelected(true);
              setSelectedId(
                response?.data?.selectedPatientAssesmentType[0]?.id
              );
              setSelectedAssessmentType((prevState: any) => ({
                ...prevState,
                id: response!.data.selectedPatientAssesmentType[0]?.id,
              }));

              localStorage.setItem(
                "selectedAType",
                JSON.stringify(
                  response!.data.selectedPatientAssesmentType[0]?.id
                )
              );
            }
          } else {
            setIsAssessmentSelected(false);
            //setSelectedId(0);
            setSelectedAssessmentType((prevState: any) => ({
              ...prevState,
              id: 0,
            }));
          }
        }
      })
      .catch((error) => {
        history.push("/confirmation", {});
      });
  }

  console.log("isAssessmentSelected: ", isAssessmentSelected);
  console.log("selectedAssessmentType: ", selectedAssessmentType);

  return (
    <IonPage placeholder={undefined}>
      <IonModal
        className="assessment-description-modal-wrap"
        backdropDismiss={false}
        isOpen={assessmentDescModal}
        placeholder={undefined}
      >
        <AssessmentDescription
          setShowModal1={setShowModal1}
        ></AssessmentDescription>
      </IonModal>
      <IonHeader
        className="ion-no-border select-an-assessment-page-header"
        placeholder={undefined}
      >
        <TopLeftUserName headerText={"Assessment Selection"}></TopLeftUserName>
        <div
          className="cross-icon"
          onClick={() => {
            redirectToPatientPage();
          }}
        >
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5 31C24.5081 31 31 24.5081 31 16.5C31 8.49187 24.5081 2 16.5 2C8.49187 2 2 8.49187 2 16.5C2 24.5081 8.49187 31 16.5 31Z"
              fill="white"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3332 21.3332L11.6667 11.6666"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3333 11.6666L11.6667 21.3333"
              stroke="#31344E"
              strokeWidth="3.22222"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="main-heading">
          <h1>Select Assessment Type</h1>
        </div>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid
          className="container select-an-assessment-page"
          placeholder={undefined}
        >
          <div className="select-assesment-wrap">
            <IonRadioGroup placeholder={undefined} value={selectedId}>
              {AssessmentType &&
                AssessmentType.map((type: any) => {
                  return (
                    <IonItem
                      key={type.id}
                      placeholder={undefined}
                      lines="none"
                      className={
                        isAssessmentSelected && selectedId === type.id
                          ? "assesment-card active"
                          : "assesment-card"
                      }
                    >
                      <IonLabel placeholder={undefined}> {type.name}</IonLabel>
                      <IonRadio
                        value={type.id}
                        placeholder={undefined}
                        onClick={() => {
                          assessmentTypeSelected(type.id);
                        }}
                      ></IonRadio>
                    </IonItem>
                  );
                })}
            </IonRadioGroup>
          </div>
          <div className="select-assesment-wrap">
            <div className="main-heading">
              <h1>Audio Instructions</h1>
            </div>
            <IonRadioGroup
              placeholder={undefined}
              value={audioInstructionsEnabled}
            >
              <IonItem
                placeholder={undefined}
                lines="none"
                className={
                  audioInstructionsEnabled === true
                    ? "assesment-card active"
                    : "assesment-card"
                }
              >
                <IonLabel placeholder={undefined}>On</IonLabel>
                <IonRadio
                  value={true}
                  placeholder={undefined}
                  onClick={() => setAudioInstructionsEnabled(true)}
                ></IonRadio>
              </IonItem>
              <IonItem
                placeholder={undefined}
                lines="none"
                className={
                  audioInstructionsEnabled === false
                    ? "assesment-card active"
                    : "assesment-card"
                }
              >
                <IonLabel placeholder={undefined}>Off</IonLabel>
                <IonRadio
                  value={false}
                  placeholder={undefined}
                  onClick={() => setAudioInstructionsEnabled(false)}
                ></IonRadio>
              </IonItem>
            </IonRadioGroup>
          </div>
          <div className="select-assesment-wrap">
            <div className="main-heading">
              <h1>Control</h1>
            </div>
            <IonRadioGroup placeholder={undefined} value={assessmentControl}>
              <IonItem
                placeholder={undefined}
                lines="none"
                className={
                  assessmentControl === "remote"
                    ? "assesment-card active"
                    : "assesment-card"
                }
              >
                <IonLabel placeholder={undefined}>Remote</IonLabel>
                <IonRadio
                  value="remote"
                  placeholder={undefined}
                  onClick={() => setAssessmentControlSelection("remote")}
                ></IonRadio>
              </IonItem>
              <IonItem
                placeholder={undefined}
                lines="none"
                className={
                  assessmentControl === "gestures"
                    ? "assesment-card active"
                    : "assesment-card"
                }
              >
                <IonLabel placeholder={undefined}>Hand gestures</IonLabel>
                <IonRadio
                  value="gestures"
                  placeholder={undefined}
                  onClick={() => setAssessmentControlSelection("gestures")}
                ></IonRadio>
              </IonItem>
            </IonRadioGroup>
          </div>
        </IonGrid>
      </IonContent>
      <IonFooter className="ion-no-border" placeholder={undefined}>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="btn-wrap-sec">
                <IonButton
                  className="generic-btn bg-blue"
                  disabled={isDisabled}
                  onClick={() => {
                    redirectToAssessmentInfoPage();
                  }}
                  placeholder={undefined}
                >
                  Angle Calibration
                </IonButton>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};
export default SelectAssessmentType;
